import Vue from 'vue';
import VueRouter from 'vue-router';
import * as auth from 'core/auth';
import moment from 'moment';
import AboutComponent from './views/about';
import AccountBonusesComponent from './views/account/bonuses';
import AccountComponent from './views/account';
import AccountCouponsComponent from './views/account/coupons';
import AccountOrdersComponent from './views/account/orders';
import AccountCorporateComponent from './views/account/corporate';
import AccountProfileComponent from './views/account/profile';
import AccountProfileEmailComponent from './views/account/profile/email';
import AccountProfilePhoneComponent from './views/account/profile/phone';
import AccountSettingsComponent from './views/account/settings';
import AccountSettingsPasswordComponent from './views/account/settings/password';
import AccountSettingsRemovalComponent from './views/account/settings/removal';
import AccountWelcomeComponent from './views/account/welcome';
import AccountWelcomePasswordComponent from './views/account/welcome/password';
import AccountProductsBuyComponent from './views/account/products/buy';
import AccountProductsBuyOrderComponent from './views/account/products/buy/order';
import AccountUnsubscribeComponent from './views/account/unsubscribe';
import Error404Component from './views/error404';
import FlightsBookingComponent from './views/flights/booking';
import FlightsComponent from './views/flights';
import FlightsSearchResultsComponent from './views/flights/search-results';
import HomeComponent from './views/home';
import OrderBookingProductComponent from './views/order/booking/product';
import OrderComponent from './views/order';
import OrderPaymentComponent from './views/order/payment';
import OrderServiceComponent from './views/order/service';
import OrderViewComponent from './views/order/view';
import PartnerComponent from './views/partner';
import PasswordComponent from './views/password';
import PasswordNewComponent from './views/password/new';
import RegistrationComponent from './views/registration';
import RentalCarsComponent from './views/rentalcars';
import SignInComponent from './views/signin';
import SupportComponent from './views/support';
import SupportNewComponent from './views/support/new';
import SupportListComponent from './views/support/list';
import SupportAllrequestsComponent from './views/support/allrequests';
import TermsComponent from './views/terms';
import TestComponent from './views/test';
import TrainsComponent from './views/trains';

Vue.use(<any>VueRouter);

export const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: HomeComponent, meta: { gaTitle: 'Home' } },
        { path: '/about', component: AboutComponent, meta: { gaTitle: 'About' } },
        { path: '/account', component: AccountComponent, meta: { gaTitle: 'Account' } },
        { path: '/account/bonuses', component: AccountBonusesComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Bonuses' } },
        { path: '/account/coupons', component: AccountCouponsComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Coupons' } },
        { path: '/account/orders', component: AccountOrdersComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Orders' } },
        { path: '/account/corporate', component: AccountCorporateComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Corporate account' } },
        { path: '/account/password', component: PasswordComponent, beforeEnter: auth.AuthService.routeAnonymousOnly, meta: { gaTitle: 'Password' } },
        { path: '/account/password/new', component: PasswordNewComponent, beforeEnter: auth.AuthService.routeAnonymousOnly, meta: { gaTitle: 'Password / New' } },
        { path: '/account/profile', component: AccountProfileComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Profile' } },
        { path: '/account/profile/email', component: AccountProfileEmailComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Profile / Email' } },
        { path: '/account/profile/phone', component: AccountProfilePhoneComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Profile / Phone' } },
        { path: '/account/settings', component: AccountSettingsComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Settings' } },
        { path: '/account/settings/password', component: AccountSettingsPasswordComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Settings / Password' } },
        { path: '/account/settings/removal', component: AccountSettingsRemovalComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Settings / Removal' } },
        { path: '/account/welcome', component: AccountWelcomeComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Welcome' } },
        { path: '/account/welcome/password', component: AccountWelcomePasswordComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Welcome / Password' } },
        { path: '/account/products/buy', component: AccountProductsBuyComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Products / Buy' } },
        { path: '/account/products/buy/:orderGuid', component: AccountProductsBuyOrderComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, props: true, meta: { gaTitle: 'Products / Buy / Order' } },
        { path: '/account/unsubscribe', component: AccountUnsubscribeComponent, meta: { gaTitle: 'Account / Unsubscribe' } },
        { path: '/cars', component: RentalCarsComponent, meta: { gaTitle: 'Rentalcars' } },
        { path: '/flights', component: FlightsComponent, meta: { gaTitle: 'Flights' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchPassengers/:searchClass/:searchFilters?', name: 'flightSearch', component: FlightsSearchResultsComponent, props: true, meta: { gaTitle: 'Flights / Search results' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchPassengers/:searchClass/booking/:searchId/:flightId', name: 'flightBooking', component: FlightsBookingComponent, props: true, meta: { gaTitle: 'Flights / Booking' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchFrom2/:searchTo2/:searchDate2/:searchPassengers/:searchClass/:searchFilters?', name: 'flightSearchRoundtrip', component: FlightsSearchResultsComponent, props: true, meta: { gaTitle: 'Flights / Search results' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchFrom2/:searchTo2/:searchDate2/:searchPassengers/:searchClass/booking/:searchId/:flightId', name: 'flightBookingRoundtrip', component: FlightsBookingComponent, props: true, meta: { gaTitle: 'Flights / Booking' } },
        {
            path: '/flights/:searchFrom/:searchTo/:searchFilters?', redirect: route => {
                route.params.searchFrom2 = route.params.searchTo;
                route.params.searchTo2 = route.params.searchFrom;
                route.params.searchDate = moment().add(7, 'd').format('MMDD');
                route.params.searchDate2 = moment().add(14, 'd').format('MMDD');
                route.params.searchClass = 'e';
                route.params.searchPassengers = '100';

                return '/flights/:searchFrom/:searchTo/:searchDate/:searchFrom2/:searchTo2/:searchDate2/:searchPassengers/:searchClass/:searchFilters?';
            }
        },
        { path: '/order', component: OrderComponent, meta: { gaTitle: 'Order' } },
        { path: '/order/booking/product/:orderGuid/:productId', component: OrderBookingProductComponent, props: true, meta: { gaTitle: 'Order / Booking / Product' } },
        { path: '/order/service', component: OrderServiceComponent, meta: { gaTitle: 'Order / Service' } },
        { path: '/order/payment/:orderGuid/:billPublicId?', name: 'order-payment', component: OrderPaymentComponent, props: true, meta: { gaTitle: 'Order / Payment' } },
        { path: '/order/payment/:orderGuid/:billPublicId/message-:message', component: OrderPaymentComponent, props: true, meta: { gaTitle: 'Order / Payment' } },
        { path: '/order/:orderGuid', component: OrderViewComponent, props: true, meta: { gaTitle: 'Order / View' } },
        { path: '/registration', component: RegistrationComponent, beforeEnter: auth.AuthService.routeAnonymousOnly, meta: { gaTitle: 'Registration' } },
        { path: '/signin', component: SignInComponent, beforeEnter: auth.AuthService.routeAnonymousOnly, meta: { gaTitle: 'Signin' } },
        { path: '/support', component: SupportComponent, meta: { gaTitle: 'Support' } },
        { path: '/support/new', component: SupportNewComponent, meta: { gaTitle: 'Support / New' } },
        { path: '/support/list', component: SupportListComponent, meta: { gaTitle: 'Support / List' } },
        { path: '/support/allrequests', component: SupportAllrequestsComponent, meta: { gaTitle: 'Support / Allrequests' } },
        {
            path: '/terms',
            component: TermsComponent,
            props: { contentId: 'terms' },
            meta: { gaTitle: 'Terms' }
        },
        {
            path: '/terms-:name',
            component: TermsComponent,
            props: route => ({ contentId: `terms${route.params.name}` }),
            meta: { gaTitle: 'Terms' }
        },
        { path: '/test', component: TestComponent },
        /*{ path: '/trains', component: TrainsComponent, meta: { gaTitle: 'Trains' } },*/
        {
            path: '/partner',
            component: PartnerComponent,
            props: (route) => ({
                searchId: route.query.sid,
                flightId: route.query.fid,
                partnerName: route.query.pn
            }),
            meta: { gaTitle: 'Partner' }
        },
        { path: '*', component: Error404Component } // Not found
    ]
});

router.afterEach((to) => {
    (<any>Vue).prototype.$ga.sendPageview(to.fullPath, to.meta.gaTitle ? to.meta.gaTitle : window.document.title);
    // Fix for bug when modal was not closed before push to new route
    document.body.classList.remove('with-modal');
});

export default router;
